import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  Button,
  Image,
  List,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
  Segment,
} from 'semantic-ui-react';

function KybReviewDetailsModal({ open, onClose, onConfirm, isLoading }) {
  const { ktp, bankAccount } = useSelector(state => state.kyb.businessDetail);

  const banks = useSelector(state => state.global.banks);
  const getBankName = bankId => banks.find(b => b.id === bankId).name;

  return (
    <Modal open={open}>
      <ModalHeader>Review Details</ModalHeader>
      <ModalContent>
        <Segment>
          <h3>ID</h3>
          {!!ktp && (
            <List>
              <List.Item>
                <strong>Name:</strong> {ktp.name}
              </List.Item>
              <List.Item>
                <strong>ID Number:</strong> {ktp.number}
              </List.Item>
              <List.Item>
                <strong>ID Photo:</strong>
                <br />
                <Image src={ktp.image} size="large" />
              </List.Item>
            </List>
          )}
        </Segment>
        <Segment>
          <h3>Bank Account</h3>
          {!!bankAccount && (
            <List>
              <List.Item>
                <strong>Name:</strong> {bankAccount.account_holder_name}
              </List.Item>
              <List.Item>
                <strong>Bank Name:</strong> {getBankName(bankAccount.bank_id)}
              </List.Item>
              <List.Item>
                <strong>Account Number:</strong>{' '}
                {bankAccount.account_holder_number}
              </List.Item>
            </List>
          )}
        </Segment>
      </ModalContent>
      <ModalActions>
        <Button onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          primary
          onClick={onConfirm}
          disabled={isLoading}
          loading={isLoading}
        >
          Confirm Detail
        </Button>
      </ModalActions>
    </Modal>
  );
}

KybReviewDetailsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default KybReviewDetailsModal;
